import { StyleSheet } from 'react-native'

export default StyleSheet.create({
  rootContainer: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    marginVertical: 24,
  },
})
